<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>疗养院管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="add">
                新增
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px;">
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="name" align="center" label="名称">
        </el-table-column>

        <el-table-column prop="detailAddress" align="center" label="地址">
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要删除该条数据？"
              v-on:confirmed="deleteItem(scope.row.id)"
            >
              <span>删除</span>
            </confirm-button>
            <el-button type="text" @click="detailItem(scope.row.id)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {},
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  mounted: function() {
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        page: this.pager.pageIndex,
        size: this.pager.pageSize
      });
      this.$http({
        url: global.apiUrl + "/recuperate/address/list",
        method: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data && res.body.data.data.length > 0) {
              this.tableData = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {

            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    add: function() {
      this.$router.push({
        name: "convalescenceManagementAdd"
      });
    },
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/recuperate/recuperateAddress?id=" + id,
        method: "DELETE"
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {

          }
        })
        .catch(err => {

          console.error(err);
        });
    },
    detailItem: function(id) {
      this.$router.push({
        name: "convalescenceManagementDetail",
        query: {
          id: id
        }
      });
    },
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>

<style lang="less" scoped>
.el-form-item__content {
  margin-left: 0px !important;
  margin-bottom: 0 !important;
}
.el-form-item {
  margin-bottom: 0;
}
.el-row--flex.is-justify-end {
  margin-top: 50px;
}
</style>
